export default "__VITE_ASSET__BEEe3hue__"